import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import info from './modules/info'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  modules: {
    info
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js